import { render, staticRenderFns } from "./MainLedgerListFast.vue?vue&type=template&id=2ff93d74&scoped=true"
import script from "./MainLedgerListFast.vue?vue&type=script&lang=js"
export * from "./MainLedgerListFast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff93d74",
  null
  
)

export default component.exports